// extracted by mini-css-extract-plugin
export default {"article":"article_article__3FbHw","link":"article_link__zdezZ","date":"article_date__X2hU8","btn":"article_btn__ktLAo"};